export { default as About } from "./About";
export { default as Contact } from "./Contact";
export { default as Portfolio } from "./Portfolio";
export { default as Services } from "./Services";
// export { default as Team } from "./Team";
export { default as AboutMe } from "./AboutMe";
export { default as Testimonies } from "./Testimonies";
export { default as CV } from "./CV";
